module.exports = __webpack_public_path__ + "static/media/izlozba (16).163948b4.jpg";